<div class="main-wrapper progress-list-v2">
  <div class="gradient-wrapper">
    <div class="content-wrapper first" *ngIf="raceProgress">
      <div
        class="phone-bg"
        [ngStyle]="{ 'background-image': 'url(' + appSettings.settings.urlFileDownload + '/race/uid/' + raceProgress.race.titlePicture + ')' }"
      ></div>
      <div class="results-header">
        <div class="header-photo-wrapper">
          <img src="{{ appSettings.settings.urlFileDownload }}/race/uid/{{ raceProgress.race.titlePicture }}?width=200&height=253" alt="" class="header-photo" />
        </div>

        <div class="header-description">
          <div class="header-description-subheader">
            <div class="subheader-data">
              <div class="header-name">{{ selectedRace.name }}</div>
              <div class="header-type">{{ raceProgress.race.orgTeam }}</div>
            </div>
            <img
              *ngIf="raceProgress.race.logo"
              src="{{ appSettings.settings.urlFileDownload }}/race/uid/{{ raceProgress.race.logo }}?width=50&height=50"
              alt=""
              class="subheader-logo"
            />
          </div>
          <div class="header-description-other">
            <div class="header-address header-item">
              <span>{{ selectedRace.city.address }}</span>
            </div>
            <div class="header-date header-item">
              <img src="assets/images/calendar.svg" alt="" class="header-icon" />
              <span>{{ selectedRace.date | date : 'dd.MM.yyyy' }}</span>
            </div>
            <div class="header-type2 header-item">
              <img src="assets/images/moto.svg" alt="" class="header-icon" />
              <span>{{ raceProgress.race.sportType.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="old-results">
        <div class="grid">
          <button
            class="col-12"
            type="button"
            (click)="goToNewVersion.emit()"
            pButton
            [label]="appSettings.translate[selectedLang]['oldVersion']"
          ></button>
        </div>
      </div>
      <div class="grid flex align-content-center flex-wrap">
        <div class="control-back col-fixed" style="width: 50px">
          <div class="back-button">
            <span class="pi pi-arrow-left"></span>
          </div>
        </div>
        <div class="col">
          <ng-container *ngTemplateOutlet="raceSearchCompetitorByNumberTemplate"></ng-container>
        </div>
        <div class="control-refresh col-fixed" style="width: 50px">
          <ng-container *ngTemplateOutlet="raceButtonRefreshTemplate"></ng-container>
        </div>
      </div>

      <div class="tabs-header col-12">
        <div #tabsList class="col-12 tabs-list" [ngClass]="{ scroll: isMobile }">
          <ng-container *ngFor="let tab of raceClasses">
            <div *ngIf="tab.clUid != 'MEDIA'" class="tab" [ngClass]="{ selected: selectedClass == tab }" (click)="refresh(tab.clUid)">
              {{ tab.name }}
            </div>
          </ng-container>
        </div>
        <div class="help-container col-12">
          <div class="button-container">
            <img src="assets/images/help.svg" alt="" class="clickable help-icon" />
          </div>
          <div class="legend" [ngClass]="{ column: isMobile }">
            <div class="annotation dsq_1">
              {{ appSettings.translate[selectedLang]['lapInvalid'] }}
            </div>
            <div class="annotation dsq_0">
              {{ appSettings.translate[selectedLang]['lapValid'] }}
            </div>
            <div class="annotation best_lap">
              {{ appSettings.translate[selectedLang]['bestLap'] }}
            </div>
            <div class="annotation joker">
              {{ appSettings.translate[selectedLang]['joker'] }}
            </div>
            <div class="annotation obligatory">
              {{ appSettings.translate[selectedLang]['optionalLap'] }}
            </div>
            <div class="annotation manualEdit">
              {{ appSettings.translate[selectedLang]['editedLap'] }}
            </div>

            <div class="annotation timebar">
              {{ appSettings.translate[selectedLang]['timebar'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="results-body" [ngClass]="{ 'no-rad': selectedClass == raceClasses[0] }">
        <div class="results-display-select">
          <div class="left-side">
            <div class="display-label">{{ appSettings.translate[selectedLang]['display'] }}:</div>
            <ng-container *ngTemplateOutlet="raceDisplaySelectorTemplate"></ng-container>
          </div>
          <div class="right-side">
            <div class="display-label">{{ appSettings.translate[selectedLang]['time_state'] }}:</div>
            <ng-container *ngTemplateOutlet="raceTimeStateSelectorTemplate"></ng-container>
          </div>
        </div>

        <div class="edit-line" *ngIf="selectedRace.isOrg || authService.user?.admin">
          <div class="edit-side">
            <div class="display-label">{{ appSettings.translate[selectedLang]['edit_mode'] }}:</div>
            <ng-container *ngTemplateOutlet="raceEditSwitchTemplate"></ng-container>
          </div>
        </div>

        <div #raceHead>
          <ng-container *ngTemplateOutlet="raceHeadTemplate"></ng-container>
        </div>
        <!-- <div class="race-type">{{ selectedClass?.name }}</div>
          <div class="race-time" *ngIf="raceProgress?.classes && raceProgress.classes[0]">
            {{ appSettings.translate[selectedLang]['laps'] }}: {{ raceProgress.classes[0].laps }}
            <ng-container *ngIf="raceProgress.classes[0].time">
              / {{ appSettings.translate[selectedLang]['time'] }}:
              {{ raceProgress.classes[0].time | timePeriodPipe : timeFormat }}</ng-container
            >
          </div> -->

        <div class="results-table-header">
          <div class="member">{{ appSettings.translate[selectedLang]['FIO'] }}</div>
          <div class="laps">
            {{ isMobile ? appSettings.translate[selectedLang]['laps'] : appSettings.translate[selectedLang]['laps_amount'] }}
          </div>
          <div class="place">
            <img src="assets/images/cup.svg" alt="" />
          </div>
        </div>

        <ng-container *ngIf="raceProgress">
          <ng-container *ngFor="let class of raceProgress.classes">
            <div
              #competitorrow
              [id]="competitor.registration.startNumber"
              class="results-table"
              [ngClass]="{ details: competitor.tableShowDetails, die: competitor.DNF > 0, clickable: modeEdit }"
              *ngFor="let competitor of class.registrations"
              (click)="editCompetitor(competitor, null)"
            >
              <!-- Универсальная карточка участника -->
              <app-universal-competitor-card
                [competitor]="competitor"
                [offset]="selectedRace.city.utcOffset"
                [timeFormat]="timeFormat"
                [editMode]="modeEdit"
                [isOrg]="selectedRace.isOrg"
                [showPosition]="true"
                [showLapsAmount]="true"
                [isMobile]="isMobile"
                (onEdit)="editCompetitor($event, null)"
                (onShowInfo)="clickInfo($event)"
                (onShowHof)="showHof($event)"
                (onShowRaceData)="clickRaceData($event)"
              ></app-universal-competitor-card>

              <div class="laps-header">
                <div class="laps-label">{{ appSettings.translate[selectedLang]['laps'] }}</div>
                <div class="laps-line"></div>
                <div class="laps-control clickable" *ngIf="!competitor.tableShowDetails" (click)="competitor.tableShowDetails = true">
                  {{ isMobile ? appSettings.translate[selectedLang]['show'] : appSettings.translate[selectedLang]['show_details'] }}
                </div>
                <div class="laps-control clickable" *ngIf="competitor.tableShowDetails" (click)="competitor.tableShowDetails = false">
                  {{ isMobile ? appSettings.translate[selectedLang]['hide'] : appSettings.translate[selectedLang]['hide_details'] }}
                </div>
              </div>

              <div class="laps-data">
                <div class="lap-data" *ngFor="let lap of competitor.laps; index as i">
                  <div class="lap-head">
                    <span
                      class="lap-num"
                      [ngClass]="{
                        dsq_0: lap.DSQ === 0,
                        dsq_1: lap.DSQ !== 0,
                        best_lap: i == competitor.bestLap - 1
                      }"
                      >{{ i + 1 }}</span
                    >
                    <div class="lap-time">{{ lap.time | timePeriodPipe : timeFormat }}</div>
                    <div class="lap-time-delta">
                      <ng-container *ngIf="lap.deltaLeader"
                        >{{ lap.deltaLeader < 0 ? '' : '+' }}{{ lap.deltaLeader | timePeriodPipe : '!HH:mm:ss' }}</ng-container
                      >
                    </div>
                  </div>
                  <div class="lap-points" *ngIf="competitor.tableShowDetails">
                    <div
                      class="lap-point"
                      *ngFor="let mark of lap.marks"
                      [ngClass]="{
                        timebar: mark.marshal === 999,
                        joker: mark.joker > 0,
                        obligatory: mark.obligatory === 0,
                        manualEdit: mark.manualEdit !== '',
                        gray: !mark.time && mark.obligatory === 1
                      }"
                    >
                      {{ mark.marshal === 999 ? appSettings.translate[selectedLang]['timebar'] : mark.marshal }} —
                      <ng-container *ngIf="!mark.time && mark.obligatory === 1">- -:- -:- -.- - -</ng-container>
                      <ng-container *ngIf="mark.time && time_state === 1">{{
                        mark.time | date : timeFormat : selectedRace.offset
                      }}</ng-container>
                      <ng-container *ngIf="mark.time && time_state === 3">{{ mark.deltaLap | timePeriodPipe : timeFormat }}</ng-container>
                      <ng-container *ngIf="mark.time && time_state === 2">{{ mark.delta | timePeriodPipe : timeFormat }}</ng-container>
                      <ng-container *ngIf="mark.time && time_state === 4">{{ mark.deltaStart | timePeriodPipe : timeFormat }}</ng-container>
                      <ng-container *ngIf="mark.time && time_state === 5">{{ mark.deltaLeader | timePeriodPipe : timeFormat }}</ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Диалог зала славы участника -->
<p-dialog *ngIf="showCompetitorHofModal"
  [header]="appSettings.translate[appSettings.selectedLang]['competitor_hof_dialog'] + ': ' + (selectedHofUser?.name || '')" [modal]="true" [draggable]="true"
  [visible]="showCompetitorHofModal" [style]="{minWidth: '400px', maxWidth: '800px'}" [closable]="false"
  (onHide)="showCompetitorHofModal = false">
  <race-hof *ngIf="selectedHofUser" [user]="selectedHofUser"></race-hof>
  <p-footer>
    <div class="ui-inputgroup document-buttons">
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['close']"
        (click)="showCompetitorHofModal = false"></p-button>
    </div>
  </p-footer>
</p-dialog>

<svg
  width="17"
  height="18"
  viewBox="0 0 17 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="display-icon"
  [style.display]="'none'"
  [ngClass]="{ selected: selectedDisplay == 'short' }"
>
  <symbol id="display-icon-details" width="17" height="18" viewBox="0 0 17 18" fill="none">
    <circle cx="2" cy="2" r="2" fill="#F1F2F3" />
    <circle cx="2" cy="9" r="2" fill="#F1F2F3" />
    <circle cx="2" cy="16" r="2" fill="#F1F2F3" />
    <rect x="6" width="11" height="4" rx="2" fill="#F1F2F3" />
    <rect x="6" y="7" width="11" height="4" rx="2" fill="#F1F2F3" />
    <rect x="6" y="14" width="11" height="4" rx="2" fill="#F1F2F3" />
  </symbol>
</svg>

<svg
  width="4"
  height="18"
  viewBox="0 0 4 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="display-icon"
  [style.display]="'none'"
  [ngClass]="{ selected: selectedDisplay == 'detail' }"
>
  <symbol id="display-icon-short" width="17" height="18" viewBox="0 0 17 18" fill="none">
    <circle cx="2" cy="2" r="2" fill="#254C74" />
    <circle cx="2" cy="9" r="2" fill="#254C74" />
    <circle cx="2" cy="16" r="2" fill="#254C74" />
  </symbol>
</svg>

<ng-template #raceHeadTemplate>
  <div class="race-head">
    <div class="race-type">{{ selectedClass.name }}</div>
    <!-- TODO проверить. Может тут можно использовать selectedClass дальше? -->
    <div class="race-time" *ngIf="raceProgress && raceProgress.classes.length > 0">
      {{ appSettings.translate[selectedLang]['laps'] }}: {{ raceProgress.classes[0].class.raceLaps }}
      <ng-container *ngIf="raceProgress.classes[0].class.raceTime">
        / {{ appSettings.translate[selectedLang]['time'] }}: {{ raceProgress.classes[0].class.raceTime| timePeriodPipe : timeFormat }}</ng-container
      >
    </div>
  </div>
</ng-template>

<ng-template #raceDisplaySelectorTemplate>
  <div class="display-selector">
    <div class="display-switcher">
      <span class="display-switch l" [ngClass]="{ selected: selectedDisplay == 'short' }" (click)="changeDisplayType('short')">
        <svg width="4" height="18" viewBox="0 0 4 18" fill="none">
          <use xlink:href="#display-icon-short"></use>
        </svg>
      </span>
      <span class="display-switch r" [ngClass]="{ selected: selectedDisplay == 'detail' }" (click)="changeDisplayType('detail')">
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none">
          <use xlink:href="#display-icon-details"></use>
        </svg>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #raceTimeStateSelectorTemplate>
  <div class="time-state-selector">
    <p-dropdown
      [options]="appSettings.time_states"
      [(ngModel)]="time_state"
      (onChange)="timeStateChange($event.value)"
      placeholder="Не выбрано"
      dropdownIcon="pi pi-caret-down"
    >
      <ng-template let-state pTemplate="selectedItem">
        <div class="flex align-items-center gap-2">
          <div>{{ appSettings.translate[appSettings.selectedLang][state.label] }}</div>
        </div>
      </ng-template>
      <ng-template let-state pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ appSettings.translate[appSettings.selectedLang][state.label] }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
</ng-template>

<ng-template #raceEditSwitchTemplate>
  <p-inputSwitch [(ngModel)]="modeEdit" class="inputgroup-input"></p-inputSwitch>
</ng-template>

<ng-template #raceButtonRefreshTemplate>
  <div class="button-container" (click)="refresh(selectedClass.clUid)">
    <img src="assets/images/refresh.svg" alt="" class="refresh-icon" />
  </div>
</ng-template>

<ng-template #raceSearchCompetitorByNumberTemplate>
  <div class="col p-0">
    <div class="p-inputgroup">
      <input
        type="text"
        pInputText
        #input
        (keyup)="filterCompetitorsList(input)"
        [placeholder]="appSettings.translate[appSettings.selectedLang]['search_placeholder']"
      />
      <button type="button" pButton pRipple icon="pi pi-times" (click)="clearFilter(input)"></button>
    </div>
  </div>
</ng-template>

<div #topNavigation class="top_navigation">
  <div class="container">
    <ng-container *ngTemplateOutlet="raceHeadTemplate"></ng-container>
    <div class="short-navigation">
      <ng-container *ngTemplateOutlet="raceDisplaySelectorTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="raceTimeStateSelectorTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="raceSearchCompetitorByNumberTemplate"></ng-container>
      <ng-container *ngIf="selectedRace.isOrg || authService.user?.admin">
        <ng-container *ngTemplateOutlet="raceEditSwitchTemplate"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="raceButtonRefreshTemplate"></ng-container>
    </div>
  </div>
</div>
